var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-grid',{ref:"grid",attrs:{"url":_vm.url,"columns":_vm.columns,"title":_vm.title,"actions":_vm.actions,"onRowClicked":_vm.onRowClicked,"navigationPath":"onRowClicked","navigationField":"onRowClicked","beforeSetupGrid":_vm.beforeSetupGrid,"freezeHeader":true,"summaryOptions":{
        enabled: true,
        columns: [
            'price',
            'yeshivaKetanaCamp',
            'registrationFee',
            'transportationFee',
            'laundryFee',
            'discount' ],
    },"expandedOptions":{
        enabled: true,
        allowExpandingAll: true,
        template: 'ykc-account-details',
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }